/** Prolific URL helpers — used only by the Prolific study flow. */

function queryFromSearch(search) {
  const params = {};
  const q = (search || '').replace(/^\?/, '');
  if (!q) return params;
  q.split('&').forEach(pair => {
    const [rawKey, rawVal] = pair.split('=');
    if (!rawKey) return;
    params[decodeURIComponent(rawKey)] = decodeURIComponent(rawVal || '');
  });
  return params;
}

/**
 * Merge route query with window.location.search.
 * Needed because hash-mode Vue Router ignores ?params before the #,
 * and Prolific puts PROLIFIC_PID on the real query string.
 */
export function getLocationQuery(routeQuery = {}) {
  const fromWindow = typeof window !== 'undefined'
    ? queryFromSearch(window.location.search)
    : {};
  return { ...fromWindow, ...routeQuery };
}

export function parseProlificParams(query = {}) {
  const q = getLocationQuery(query);
  return {
    PROLIFIC_PID: q.PROLIFIC_PID || q.prolific_pid || null,
    STUDY_ID: q.STUDY_ID || q.study_id || null,
    SESSION_ID: q.SESSION_ID || q.session_id || null,
    graph_id: q.graph_id || null,
  };
}

export function hasProlificParams(query = {}) {
  // Prolific ID alone is enough to skip login
  const p = parseProlificParams(query);
  return Boolean(p.PROLIFIC_PID);
}

export function collectDeviceInfo() {
  return {
    user_agent: navigator.userAgent,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    language: navigator.language,
    platform: navigator.platform,
  };
}

export function routeForPhase(session) {
  const id = session.id;
  switch (session.phase) {
    case 'started':
    case 'consent':
      return `/prolific/study/${id}/consent`;
    case 'video':
      return `/prolific/study/${id}/video`;
    case 'practice':
      return `/prolific/study/${id}/practice`;
    case 'screening':
      return `/prolific/study/${id}/screening`;
    case 'demographics':
    case 'training':
      // Legacy phases — send to consent/video flow
      return `/prolific/study/${id}/consent`;
    case 'main':
      // Returning participants already in main go to labeling; fresh pass uses main-intro from screening
      return `/prolific/study/${id}/main`;
    case 'post_survey':
      return `/prolific/study/${id}/post-study`;
    case 'completed':
      return `/prolific/study/${id}/finish`;
    case 'screened_out':
    case 'declined':
      return `/prolific/study/${id}/training-result`;
    default:
      return `/prolific/study/${id}/consent`;
  }
}

/** Dev/test Prolific IDs that get a Complete shortcut in main study (test0–test9). */
export function isTestProlificPid(pid) {
  return /^test[0-9]$/.test(String(pid || ''));
}
